/*=========================================================================================
  File Name: moduleApicil.js
  Description: Apicil Module
==========================================================================================*/


import state from './moduleApicilState.js';
import mutations from './moduleApicilMutations.js';
import actions from './moduleApicilActions.js';
import getters from './moduleApicilGetters.js';

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};